import { render, staticRenderFns } from "./CalendarEventDetailsModal.vue?vue&type=template&id=27df72c1&"
import script from "./CalendarEventDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CalendarEventDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports